export default __webpack_public_path__ + "./fonts/greenFace.d1888914.svg";